export default {
  'menu.zy-hr.workbench': 'Workbench',
  'menu.zy-hr.dashboard': 'HR Dashboard',
  'menu.zy-hr.employeeCenter': 'Employee Center',
  'menu.zy-hr.employeeWorkbench': 'HR Workbench',
  'menu.zy-hr.employee': 'Employee Roster',
  'menu.zy-hr.employee.recycleBin': 'Employee Recycle Bin',
  'menu.zy-hr.employee.detail': 'Employee Detail',
  'menu.zy-hr.me': 'My Workspace',
  'menu.zy-hr.laborRelations': 'Labor Relations',
  'menu.zy-hr.employeePortalSettings': 'Employee Portal Settings',
  'menu.zy-hr.onboarding': 'Preboarding',
  'menu.zy-hr.regularization': 'Regularization',
  'menu.zy-hr.employeeChange': 'Employee Change',
  'menu.zy-hr.profileChange': 'Self-Service Profile Changes',
  'menu.zy-hr.employeeLifecycleAudits': 'Lifecycle Audits',
  'menu.zy-hr.certificateRequests': 'Certificate Requests',
  'menu.zy-hr.employeeRelationsAnalysis': 'Employee Relations Analysis',
  'menu.zy-hr.employeeCenterSettings': 'Employee Center Settings',
  'menu.zy-hr.resignation': 'Resignation',
  'menu.zy-hr.attendanceCenter': 'Attendance Center',
  'menu.zy-hr.payrollCenter': 'Payroll Center',
  'menu.zy-hr.payroll.workbench': 'Payroll Workbench',
  'menu.zy-hr.payroll.plans': 'Payroll Plans',
  'menu.zy-hr.payroll.items': 'Payroll Items',
  'menu.zy-hr.payroll.profiles': 'Employee Payroll Profiles',
  'menu.zy-hr.payroll.deductions': 'Deduction Results',
  'menu.zy-hr.payroll.adjustments': 'Salary Adjustments',
  'menu.zy-hr.payroll.runs': 'Payroll Runs',
  'menu.zy-hr.payroll.slips': 'Payroll Slips',
  'menu.zy-hr.socialInsuranceCenter': 'Social Insurance Center',
  'menu.zy-hr.socialInsurance.workbench': 'Social Insurance Workbench',
  'menu.zy-hr.socialInsurance.policies': 'Insurance Policies',
  'menu.zy-hr.socialInsurance.accounts': 'Insurance Accounts',
  'menu.zy-hr.socialInsurance.changes': 'Enrollment Changes',
  'menu.zy-hr.socialInsurance.bills': 'Contribution Bills',
  'menu.zy-hr.performanceCenter': 'Performance Center',
  'menu.zy-hr.performance.cycles': 'Performance Cycles',
  'menu.zy-hr.performance.goals': 'Performance Goals',
  'menu.zy-hr.performance.reviews': 'Performance Reviews',
  'menu.zy-hr.performance.interviews': 'Performance Interviews',
  'menu.zy-hr.performance.results': 'Performance Results',
  'menu.zy-hr.performance.gradeRules': 'Grade Rules',
  'menu.zy-hr.trainingLearningCenter': 'Training & Learning Center',
  'menu.zy-hr.careerPlanning': 'Career Planning',
  'menu.zy-hr.talentInventory': 'Talent Inventory',
  'menu.zy-hr.foundationConfig': 'Foundation Config',
  'menu.zy-hr.processReminder': 'Workflow & Reminders',
  'menu.zy-hr.approval': 'My Approvals',
  'menu.zy-hr.approvalRecords': 'Approval Records',
  'menu.zy-hr.approvalAbnormalRecords': 'Abnormal Approval Records',
  'menu.zy-hr.approvalDelegates': 'Approval Delegates',
  'menu.zy-hr.approvalHandovers': 'Approval Handovers',
  'menu.zy-hr.approvalInstances': 'Approval Instances',
  'menu.zy-hr.approvalTemplates': 'Approval Templates',
  'menu.zy-hr.organization.unit': 'Organization Units',
  'menu.zy-hr.organization.position': 'Positions',
  'menu.zy-hr.organization.jobLevel': 'Job Levels',
  'menu.zy-hr.organization.workLocation': 'Work Locations',
  'menu.zy-hr.organization.employeeTag': 'Employee Tags',
  'menu.zy-hr.organization.roles': 'Roles & Permissions',
  'menu.zy-hr.organization.permissions': 'Permission Codes',
  'menu.zy-hr.attendance.workbench': 'Attendance Workbench',
  'menu.zy-hr.attendance.shifts': 'Shift Library',
  'menu.zy-hr.attendance.groups': 'Attendance Groups',
  'menu.zy-hr.attendance.schedules': 'Schedule Calendar',
  'menu.zy-hr.attendance.holidayPlans': 'Holiday Plans',
  'menu.zy-hr.attendance.record': 'Attendance Records',
  'menu.zy-hr.attendance.daily': 'Daily Attendance',
  'menu.zy-hr.attendance.monthly': 'Monthly Attendance',
  'menu.zy-hr.attendance.leaveBalances': 'Leave Balances',
  'menu.zy-hr.attendance.leaveGrantPolicies': 'Leave Grant Policies',
  'menu.zy-hr.attendance.leave': 'Leave Requests',
  'menu.zy-hr.attendance.overtime': 'Overtime Requests',
  'menu.zy-hr.attendance.punch': 'Punch Corrections',
  'menu.zy-hr.attendance.setting': 'Attendance Settings',
  'menu.zy-hr.reminder': 'HR Reminders',
  'menu.zy-hr.systemUpdates': 'System Updates',
  'menu.login': 'Login',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.logout': 'Logout',
};
